import { createRouter, createWebHistory } from 'vue-router'
import store from '@/configure/store'
import baseModule from './baseModule'

let moduleRoutes = []
// 基础信息
moduleRoutes = moduleRoutes.concat(baseModule)

var routes = [
  {
    path: '/',
    name: '/index',
    // redirect: '/baseModule/indexHomePage',
    component: () => import('@/pages/commonModule/indexAdminFrame/index'),
    children: [].concat(moduleRoutes)
  },
  {
    path:'/workbench',
    name:'workbench',
    component: () => import('@/pages/commonModule/indexAdminWorkbench/index')

  },
  {
    path: '/indexAdminLogin',
    component: () => import('@/pages/commonModule/indexAdminLogin/index')
  },
  {
    path: '/:pathMatch(.*)',
    name: '/index404',
    component: () => import('@/pages/commonModule/index404/index')
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = store.state.systemMetaBaseData.systemName
  if (store.state.systemMetaBaseData.systemLogo != null) {
    let $favicon = document.querySelector('link[rel="icon"]');
    if ($favicon !== null) {
      $favicon.href = store.state.systemMetaBaseData.systemLogo.systemFileUrl;
    } else {
      $favicon = document.createElement("link");
      $favicon.rel = "icon";
      $favicon.href = store.state.systemMetaBaseData.systemLogo.systemFileUrl;
      document.head.appendChild($favicon);
    }
  }
  if (to.path !== '/indexAdminLogin') {
    const lesseeManageToken = store.state.userData.lesseeManageToken
    const lesseeAdminToken = store.state.userData.lesseeAdminToken
    if (lesseeManageToken === '' || lesseeManageToken === undefined || lesseeAdminToken === '' || lesseeAdminToken === undefined) {
      next('/indexAdminLogin')
    } else {
      next()
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  document.title = store.state.systemMetaBaseData.systemName
  next()
})

export default router
